module.exports = __webpack_public_path__ + "static/78ea7d385094833a9a728a098a6c072d38a0794d193ab3612693bbdf5cfc1407-0fbf9c35b624794d4f8d7b45edaaf12a.png";